import { render, staticRenderFns } from "./MapBlock.vue?vue&type=template&id=53c285fb"
import script from "./MapBlock.vue?vue&type=script&lang=js"
export * from "./MapBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports